import { twMerge } from 'tailwind-merge';

import { Toast, ToastRegion } from '@repo/components/toast';

import { toastQueue } from './toast-queue.ts';

export function ToastViewport() {
  return (
    <ToastRegion
      aria-label="Notifications"
      queue={toastQueue}
      className={twMerge(
        'flex flex-col-reverse gap-2',
        'fixed bottom-4 right-4 z-[var(--toast-z-index)]',
        'outline-0',
      )}
    >
      {({ toast }) => (
        <Toast toast={toast} />
      )}
    </ToastRegion>
  );
}
